// Nodes modules
import './modules/@tc';
import 'classlist-polyfill';
import 'object-fit-polyfill';

import Swiper, {Navigation, EffectFade, Keyboard} from "swiper"
import { disablePageScroll, enablePageScroll, addFillGapTarget, addFillGapSelector } from 'scroll-lock';

Swiper.use([Navigation, EffectFade, Keyboard]);

window.addEventListener('load', function(){
    var body = document.body;
    var burgerBtn = document.getElementById("burger-btn");
	var $scrollableElement = document.querySelector('.my-scrollable-element');

    function toggleMainNav() {
        body.classList.toggle("menu-open");

        if (body.classList.contains('menu-open')) { 
            //console.log('open');
            disablePageScroll($scrollableElement);

            document.querySelector('.main-html').style.overflow = "hidden";
        } else {
            enablePageScroll($scrollableElement);

            //console.log('closed');
            document.querySelector('.main-html').style.overflow = "auto";
        }
    } 
    
    if (typeof(burgerBtn) != 'undefined' && burgerBtn != null) {
        burgerBtn.onclick = toggleMainNav;
    }

    // RESPONSIVE HEADER ANIMATION
    var handlerFired;
    
    window.addEventListener('scroll', function(e){
        var containerTop = document.querySelector('.jumbotron').getBoundingClientRect().top;

        if (containerTop <= 0) {
            if (!handlerFired) {
                handlerFired = 1;
                //console.log('container at top of viewport or above');
                body.classList.add('header-show');
            }    
        }

        if (containerTop > 0) {
            handlerFired = 0;
            
            if (body.classList.contains('header-show')) { 
                //console.log('container at bottom of viewport or below');
                body.classList.remove('header-show');
            }
        }
    });

    // REPERTOIRE FILTERS RESPONSIVE
    var filtersBtn = document.getElementById("filtersBtn");

    if(filtersBtn) {
        function toggleFilters() {
            body.classList.toggle("filters-open");
        } 

        if (typeof(filtersBtn) != 'undefined' && filtersBtn != null) {
            filtersBtn.onclick = toggleFilters;
        }
    }

    // TIMELINE MASONRY
    var timelineElem = document.querySelector('.timeline-container .body');
   
    function letMasonry() {
        let width = window.innerWidth;

        if (width > 992) {
            //console.log(width);

            var timelineMsnry = new Masonry( timelineElem, {
                // options
                itemSelector: '.timeline-container .body .col-date',
                //horizontalOrder: true,
                //initLayout: false,
                //columnWidth: 200
                gutter: 48
            });
        } else {
            if(timelineMsnry) {
                timelineMsnry.destroy();
            }
        }
    }

    onresize = (event) => {
        if (timelineElem) {
            letMasonry();
        }
    };

    if (timelineElem) {
        imagesLoaded( document.querySelector('.timeline-container .body'), function( instance ) {
			//console.log('all images are loaded');
            
            letMasonry();


            var loadMoreBtn = document.querySelector('.load-more');

            if(loadMoreBtn) {				
                loadMoreBtn.addEventListener('click', e => {
                    if (timelineElem.classList.contains('add-more')) { 
                        timelineElem.classList.remove('add-more');
                    } else {
                        timelineElem.classList.add('add-more');
                    }

                    letMasonry();
                });
            }
            
           
		});
    }

    // COLLABORATIONS SLIDE
    const swiper = new Swiper('.collaborations-container .swiper-container', {
        slidesPerView: 1, 
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
          crossFade: true
        },
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }, 
    });
});
